module.exports = __webpack_public_path__ + "static/media/enter-pin.52c6ca03.svg";